<template>
    <div class="notifications_container">
        <v-menu
            offset-y
            offset-x
            :nudge-top="!$vuetify.breakpoint.xs ? '20px' : '26px'"
            :nudge-right="!$vuetify.breakpoint.xs ? '263px' : '100px'"
            :nudge-left="!$vuetify.breakpoint.xs ? '0' : '260px'"
            :max-width="$vuetify.breakpoint.xs ? 'calc(100% - 40px)' : 'none'"
            :min-width="$vuetify.breakpoint.xs ? 'calc(100% - 40px)' : '308px'"
            left
            v-model="shown"
        >
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    class="user_box pa-0 ml-2 ml-md-0 pl-sm-2"
                    rounded
                    :ripple="false"
                    depressed
                    elevation="0"
                    height="60"
                    v-bind="attrs"
                    v-on="on"
                    color="#fff"
                >
                    <v-avatar size="49px" class="d-none d-sm-flex">
                        <img v-if="userAvatar" alt="Avatar" :src="userAvatar" />
                        <v-icon
                            v-else
                            :color="user.color"
                            v-text="user.icon"
                        ></v-icon>
                    </v-avatar>
                    <v-avatar size="60px" class="d-flex d-sm-none">
                        <img v-if="userAvatar" alt="Avatar" :src="userAvatar" />
                        <v-icon
                            v-else
                            :color="user.color"
                            v-text="user.icon"
                        ></v-icon>
                    </v-avatar>
                    <span class="user_email d-none d-sm-inline">
                        {{ userEmail }}
                    </span>
                </v-btn>
            </template>
            <v-list rounded nav width="100%" class="pa-4 pt-8 sssssss">
                <div
                    :class="
                        $vuetify.breakpoint.xs
                            ? 'menu_btn_over over_mobile'
                            : 'menu_btn_over over_desktop'
                    "
                >
                    <v-avatar size="49px" class="d-none d-sm-flex">
                        <img v-if="userAvatar" alt="Avatar" :src="userAvatar" />
                        <v-icon
                            v-else
                            :color="user.color"
                            v-text="user.icon"
                        ></v-icon>
                    </v-avatar>
                    <v-avatar size="60px" class="d-flex d-sm-none">
                        <img v-if="userAvatar" alt="Avatar" :src="userAvatar" />
                        <v-icon
                            v-else
                            :color="user.color"
                            v-text="user.icon"
                        ></v-icon>
                    </v-avatar>
                </div>
                <v-list-item-group active-class="active_btn">
                    <v-list-item
                        class="user_menu_btn pa-0"
                        v-for="(item, index) in items"
                        :key="index"
                        link
                        :to="item.route"
                    >
                        <v-list-item-content class="menu_text px-4">
                            {{ item.text }}
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item
                        class="user_menu_btn pa-0"
                        @click="handleLogout"
                    >
                        <v-list-item-content class="menu_text px-4">
                            Logout
                        </v-list-item-content>
                    </v-list-item>
                </v-list-item-group>
            </v-list>
        </v-menu>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
    name: "UserMenu",
    data: () => ({
        shown: false,
        items: [
            { text: "My profile", route: "/profile" },
            { text: "My orders", route: "/orders" },
            { text: "Billing", route: "/biling" },
            // { text: "Subscription", route: "/subscriptions" },
            { text: "My notifications", route: "/notification" }
        ],
        user: {
            photo: "../assets/user2.svg",
            email: "antoxch1@gmail.com",
            color: "red",
            icon: "mdi-account-multiple"
        }
    }),
    computed: {
        ...mapGetters("user", ["userEmail", "userAvatar"])
    },
    watch: {
        shown(val) {
            if (val) {
                this.$emit("close_otification");
            }
        }
    },
    created() {
        this.getUserInfo();
    },
    methods: {
        ...mapActions("user", ["logout", "getUserInfo"]),
        handleLogout() {
            this.logout().then(() => {
                this.$router.push("/login");
            });
        }
    }
};
</script>
<style scoped>
.v-menu__content {
    box-shadow: 0px 30px 30px rgba(0, 0, 0, 0.07);
    border-radius: 20px;
    margin-left: 48px !important;
}

@media (max-width: 600px) {
    .v-menu__content {
        margin-left: 8px !important;
    }
}
.user_box {
    min-width: 0 !important;
    background-color: #fff !important;
    font-size: 14px;
    text-transform: none;
    color: #2e2e2e !important;
}

.v-btn::before {
    background-color: transparent;
}

.user_email {
    font-size: 14px;
    margin-left: 12px;
    margin-right: 28px;
}

.user_menu_btn {
    box-sizing: border-box;
}

.user_menu_btn:hover,
.user_menu_btn:active {
    background-color: #eef4ff;
}

.v-list-item--link:before {
    opacity: 0 !important;
}

.active_btn {
    background-color: #eef4ff;
    color: #2c4370 !important;
}

.menu_btn_over {
    background-color: #fff;
    position: absolute;
    top: -34px;
}

.over_desktop {
    left: 7px;
}

.over_mobile {
    right: -4px;
}

.menu_text {
    color: #2c4370;
    font-size: 14px;
}

</style>
